import React from 'react';
import Mole from './Mole';
import './GameBoard.css';

const GameBoard = ({ activeMoles, onWhackMole, characterTypes, moleCharacters }) => {
  const holes = Array.from({ length: 12 }, (_, index) => index);

  return (
    <div className="holes">
      {holes.map((holeIndex) => (
        <div 
          key={holeIndex}
          className="hole" 
          data-hole={holeIndex}
          onClick={() => onWhackMole(holeIndex)}
          onTouchStart={(e) => {
            e.preventDefault();
            onWhackMole(holeIndex);
          }}
        >
          <Mole 
            holeIndex={holeIndex}
            isActive={activeMoles.has(holeIndex)}
            characterTypes={characterTypes}
            characterType={moleCharacters.get(holeIndex)}
          />
        </div>
      ))}
    </div>
  );
};

export default GameBoard;

